/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Support_Toast_UnavailableInputs */



/**
* | output |
* | --- |
* | "The support form is not available on this deployment. Please contact your administrator." |
*
* @param {Support_Toast_UnavailableInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const support_toast_unavailable = /** @type {((inputs?: Support_Toast_UnavailableInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Support_Toast_UnavailableInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Das Support-Formular ist in dieser Installation nicht verfügbar. Bitte wende dich an deine Administratorin oder deinen Administrator.")
	return /** @type {LocalizedString} */ ("The support form is not available on this deployment. Please contact your administrator.")
});